import {
  store,
} from '@/store';

import {
  SystemMessageData,
} from './types';

export class SystemMessagesInstance {
  public static createMessage(data: SystemMessageData): number {
    const id = Date.now();

    store.dispatch('systemMessages/add', {
      id,
      title: data.title || void 0,
      message: data.message,
      type: data.type || void 0,
      showReloadButton: data.showReloadButton || false,
    });

    return id;
  }

  public static removeMessage(id: number): void {
    store.dispatch('systemMessages/remove', id);
  }

  public static removeMessages(): void {
    store.dispatch('systemMessages/clear');
  }
}
